import moment from 'moment';
export default function toUtcDateOnlyISOString(value) {
    if (!value) {
        return null;
    }
    return moment.utc(value.format('YYYY-MM-DD')).startOf('day').toISOString();
}
